module.exports = __webpack_public_path__ + "img/sidebar-company-profile-ico-blue-01.a8b13ec5.svg";